export default __webpack_public_path__ + "static/media/contract.d186a3d7.svg";